import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

function LoadingSpinner(props) {
  return (
      <CircularProgress size={60}
        thickness={7}
        color="#95BF5E" />
  );
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js